import { useEffect } from "react";
import { queryKeys } from "@/constants";
import { useQuery } from "@tanstack/react-query";
import { RequestItem } from "@/models/request";
import { NotifyService } from "@/helpers/notify";
import { requestApi } from "@/services/request";

interface UseGetListRequestProps {
  enabledToastError?: boolean;
  filterFn?: (data: RequestItem[]) => RequestItem[];
}

export const useGetListRequest = (
  { enabledToastError = false, filterFn }: UseGetListRequestProps = { enabledToastError: false }
) => {
  const query = useQuery({
    queryKey: [queryKeys.request],
    queryFn: async () => {
      const { data } = await requestApi.getList();
      if (!data) return [];
      if (filterFn) {
        return filterFn(data);
      }

      return data;
    },
  });

  useEffect(() => {
    if (query.error) {
      // eslint-disable-next-line no-console
      console.error("useGetListRequest", query.error.message);
      enabledToastError && NotifyService.error(query.error.message);
    }
  }, [query.error, enabledToastError]);

  return query;
};
